/* eslint-disable */

import type { TransactionReturnType } from "../types"
import type { Abi, Address } from "viem"
import type { Config } from "wagmi"

import { veTokenAbi } from "@/domains/abis"

import { simulatedTransaction } from "../simulated-transaction"

type MergeProps = {
  account: Address
  chainId: number
  config: Config
  vestedAddress: Address
  fromTokenId: number
  toTokenId: number
}

export const merge = async ({
  account,
  chainId,
  config,
  vestedAddress,
  fromTokenId,
  toTokenId,
}: MergeProps): Promise<TransactionReturnType> => {
  try {
    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: veTokenAbi as Abi,
        account,
        address: vestedAddress,
        args: [fromTokenId, toTokenId],
        chainId,
        functionName: "merge",
      },
    })
    return result
  } catch (error: any) {
    console.error("merge", error)
    return { success: false, error: error.message, code: error.code }
  }
}

/*
const merge = async ({ web3, fromTokenId, toTokenId, account, gasPrice, vestedAddress }) => {
  const options = { from: account }
  if (gasPrice) {
    options["gasPrice"] = gasPrice
  }
  try {
    const veTokenContract = new web3.eth.Contract(veTokenAbi, vestedAddress)
    const tx = await veTokenContract.methods.merge(fromTokenId, toTokenId).send(options)
    return { tx, success: true }
  } catch (error: any) {
    console.error("merge", error)
    // @ts-ignore
    return { tx: null, success: false, error: error.message, code: error.code }
  }
}
*/
